import { Box, Divider, Modal } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
    onClose: () => void;
    children: ReactNode;
    actions: ReactNode;
}

export default function IdvModal({ onClose, children, actions }: Props) {
    return (
        <Modal open onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '800px',
                    maxHeight: '500px',
                    width: '100%',
                    bgcolor: 'neutral.white',
                    borderRadius: '8px',
                }}
            >
                <Box
                    sx={{
                        padding: '24px 24px 16px 24px',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                    }}
                >
                    {children}
                </Box>
                <Divider />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: '16px',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                        }}
                    >
                        {actions}
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
}
